import { render, staticRenderFns } from "./addOrganizationalManagement.vue?vue&type=template&id=3771e4de&"
import script from "./addOrganizationalManagement.vue?vue&type=script&lang=js&"
export * from "./addOrganizationalManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports